/**
 * The default order hint to use when no specific order hint is provided.
 */ export const DefaultOrderHint = " !";
